import React, { useState } from "react";
import blog_2 from "../assets/img/blog2.png";
import axios from "axios";

const Forsuppliers = () => {
  const [name, setName] = useState("");
  const [business, setBusiness] = useState("");
  const [file, setFile] = useState(null); 
  const [message, setMessage] = useState("");

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleCareers = (e) => {
    e.preventDefault();

    const formdata = new FormData();

    formdata.append("file", file);
    formdata.append("business", business);
    formdata.append("name", name);
    formdata.append("msg", message);

    axios 
      .post('/admin/send-supplier', formdata, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res) => {
        console.log("res", res);
        setName("");
        setBusiness("");
        setMessage("");
        setFile("");
        e.target.reset(); // reset the form to clear all input fields
        document.getElementById("EmailSent").style.display = "block"; // show the message
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <section className="contactus for_supplers careerspadding">
      <div
        className="container"
        style={{ position: "relative" }}
        data-aos="fade-right"
      >
        <div className="dd-titlediv">
          <h1 className="title_head_1 pd20 wwe-title smallwhite-title">
            For Suppliers
          </h1>
          <h1 className="title_head_2 tpdb-title wwe-title smallwhite-title">
          For Suppliers
          </h1>
        </div>
      </div>
      <div className="row " data-aos="fade-right" style={{ marginTop: "50px" }}>
        <div className="offset-md-2 col-md-5">
        <form onSubmit={handleCareers} encType="multipart/form-data" method="post">
            <div className="form">
              <input
                type="text"
                placeholder="Supplier Name"
                className="form-control"
                name="name"
                onChange={(e) => setName(e.target.value)}
                required
              />
              <input
                type="text"
                placeholder="Type of business"
                className="form-control"
                name="business"
                onChange={(e) => setBusiness(e.target.value)}
                required
              />
              <input
                type="file"
                placeholder="Type of business"
                className="form-control"
                name="file"
                onChange={handleFileChange}
              />
              <textarea
                placeholder="Attachments(Options)"
                className="form-control"
                rows={5}
                type="text"
                name="message"
                onChange={(e) => setMessage(e.target.value)}
              />
              <button type="submit">
                Send <i className="arrow right" />{" "}
              </button>
              <h4 id="EmailSent" style={{ display: "none",color:"lightgreen" }}>Email sent Successfully.</h4>
            </div>
          </form>
        </div>
        <div className="offset-md-1 col-md-4">
          <div className="right_image">
            <img
              alt=""
              src={blog_2}
              style={{ width: "100%" }}
              className="supplers"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Forsuppliers;
